function HideShowHeaderLogo() {
    this.build();
}

HideShowHeaderLogo.prototype.build = function () {
    let posTop = $('.page-inner').css('padding-top');
    let posTopLogo = $('.header-logo').offset().top + $('.header-logo').innerHeight();

    ScrollTrigger.create({
        trigger: ".page-inner",
        start: "top top+="+ posTopLogo,
        toggleClass: {
            targets: document.body, className: "hide-header-logo"
        }
    });
};
